"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Domain = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M19 12c0 .34-.024.673-.07 1h-2.96a16.096 16.096 0 000-2h2.96c.046.327.07.66.07 1zm-5.035-1a13.995 13.995 0 010 2h-3.93a13.995 13.995 0 010-2h3.93zm1.744-2h2.617a7.022 7.022 0 00-4.091-3.636c.656.886 1.174 2.15 1.474 3.636zM9.765 5.364A7.021 7.021 0 005.674 9H8.29c.3-1.486.818-2.75 1.474-3.636zM10.339 9c.164-.68.378-1.275.621-1.762.279-.558.56-.9.775-1.082a.852.852 0 01.216-.142A.215.215 0 0112 6l.01.001a.215.215 0 01.039.013c.04.016.113.054.216.142.216.182.496.524.775 1.082.243.487.457 1.082.621 1.762H10.34zM8.03 11h-2.96a7.06 7.06 0 000 2h2.96a16.072 16.072 0 010-2zm.26 4H5.674a7.022 7.022 0 004.091 3.636c-.656-.886-1.173-2.15-1.474-3.636zm5.944 3.636A7.022 7.022 0 0018.326 15H15.71c-.3 1.486-.818 2.75-1.474 3.636zM13.661 15H10.34c.164.68.378 1.275.621 1.762.279.558.56.9.775 1.082a.853.853 0 00.216.142A.211.211 0 0012 18a.211.211 0 00.049-.014.853.853 0 00.216-.142c.216-.182.496-.524.775-1.082A8.352 8.352 0 0013.66 15zM21 12a9 9 0 11-18 0 9 9 0 0118 0z",
        clipRule: "evenodd"
      }
    )
  );
};
export default Domain;
